import { useCallback, useEffect, useRef, useState } from 'react';
import getClients from '../../api/clients/getClients';
import useDebounce from '../../hooks/useDebounce';
import Select from '../Select/Select';

const mergeUniqueClients = (prev, next) => {
  const seen = new Set(prev.map((item) => item.value));
  const filtered = next.filter((item) => {
    if (seen.has(item.value)) return false;
    seen.add(item.value);
    return true;
  });
  return [...prev, ...filtered];
};

// ÐÐÐ Ð² Ð»ÐµÐ¹Ð±Ð»Ðµ Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÐµÐ½: Ð¿Ð¾Ð»Ð½ÑÑ ÑÑÐ·Ð¾Ðº Ð² Ð±Ð°Ð·Ðµ ÑÐ²Ð°ÑÐ°ÐµÑ, Ð±ÐµÐ· Ð½ÐµÐ³Ð¾ Ð² ÑÐ¿Ð¸ÑÐºÐµ
// Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¾ Ð¾Ð´Ð¸Ð½Ð°ÐºÐ¾Ð²ÑÑ ÑÑÑÐ¾Ðº Ð¸ Ð²ÑÐ±ÑÐ°ÑÑ Ð½ÑÐ¶Ð½ÑÑ Ð½ÐµÐ²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾.
const toOption = (item) => ({
  value: item.id,
  label: `${item.name} ${item.surname}` + (item.iin ? ` (ÐÐÐ: ${item.iin})` : ''),
  client: item,
});

const SelectClients = ({ handleSetSelect, handleSetState, style, excludeIds, ...props }) => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const debouncedSearch = useDebounce(search, 500);

  // Ð¤Ð»Ð°Ð³ Ð² ref, Ð° Ð½Ðµ ÑÐ¾Ð»ÑÐºÐ¾ Ð² state: Ð¿Ð¾Ð´Ð³ÑÑÐ·ÐºÐ° ÑÐ»ÐµÐ´ÑÑÑÐµÐ¹ ÑÑÑÐ°Ð½Ð¸ÑÑ Ð´ÑÑÐ³Ð°ÐµÑÑÑ Ð¸Ð·
  // IntersectionObserver ÑÑÐ°Ð·Ñ Ð¿Ð¾ÑÐ»Ðµ Ð¾ÑÐ²ÐµÑÐ°, ÐºÐ¾Ð³Ð´Ð° setLoading ÐµÑÑ Ð½Ðµ Ð¿ÑÐ¸Ð¼ÐµÐ½Ð¸Ð»ÑÑ.
  const loadingRef = useRef(false);
  // ÐÐ¾Ð¼ÐµÑ Ð·Ð°Ð¿ÑÐ¾ÑÐ°: Ð¾ÑÐ²ÐµÑ Ð½Ð° ÑÑÑÐ°ÑÐµÐ²ÑÐ¸Ð¹ (Ð¿Ð¾ÐºÐ° Ð»ÐµÑÐµÐ» â ÑÐ¼ÐµÐ½Ð¸Ð»ÑÑ Ð¿Ð¾Ð¸ÑÐº) Ð²ÑÐ±ÑÐ°ÑÑÐ²Ð°ÐµÐ¼,
  // Ð¸Ð½Ð°ÑÐµ Ðº Ð½Ð°Ð¹Ð´ÐµÐ½Ð½ÑÐ¼ ÐºÐ»Ð¸ÐµÐ½ÑÐ°Ð¼ Ð¿Ð¾Ð´ÐºÐ»ÐµÐ¸ÑÑÑ ÑÑÑÐ°Ð½Ð¸ÑÐ° Ð¸Ð· Ð¿ÑÐ¾ÑÐ»Ð¾Ð³Ð¾ Ð·Ð°Ð¿ÑÐ¾ÑÐ°.
  const seqRef = useRef(0);

  const userId = new URLSearchParams(window.location.search).get('userId');

  const load = useCallback(
    (pageToLoad, term) => {
      const seq = ++seqRef.current;
      loadingRef.current = true;
      setLoading(true);

      // ÐÐ°Ð³Ð¸Ð½Ð°ÑÐ¸Ñ Ð´Ð¾Ð»Ð¶Ð½Ð° Ð¸Ð´ÑÐ¸ Ñ ÑÐµÐ¼ Ð¶Ðµ ÑÐ¸Ð»ÑÑÑÐ¾Ð¼, ÑÑÐ¾ Ð¸ Ð¿Ð¾Ð¸ÑÐº, Ð¸Ð½Ð°ÑÐµ Ðº Ð½Ð°Ð¹Ð´ÐµÐ½Ð½ÑÐ¼
      // ÐºÐ»Ð¸ÐµÐ½ÑÐ°Ð¼ Ð¿Ð¾Ð´ÐºÐ»ÐµÐ¸Ð²Ð°ÑÑÑÑ ÑÑÑÐ°Ð½Ð¸ÑÑ Ð²ÑÐµÐ³Ð¾ ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐ°.
      const params = { page: pageToLoad };
      // Ð¦Ð¸ÑÑÑ â ÑÑÐ¾ ÐÐÐ Ð¸Ð»Ð¸ ÑÐµÐ»ÐµÑÐ¾Ð½: Ð¸Ñ Ð±ÑÐº Ð¸ÑÐµÑ Ð¿Ð°ÑÐ°Ð¼ÐµÑÑÐ¾Ð¼ all, Ð° fio ÑÐ¼Ð¾ÑÑÐ¸Ñ
      // ÑÐ¾Ð»ÑÐºÐ¾ Ð½Ð° Ð¸Ð¼Ñ Ð¸ ÑÐ°Ð¼Ð¸Ð»Ð¸Ñ (Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð¿Ð¾ ÐÐÐ Ð¿ÑÐ¸ÑÐ¾Ð´Ð¸Ð»Ð¾ Â«No optionsÂ»).
      if (term && /^[\d\s+()-]+$/.test(term)) params.all = term.replace(/[^\d]/g, '');
      else if (term) params.fio = term;
      else if (userId) params.id = userId;

      getClients(params)
        .then((res) => {
          if (seq !== seqRef.current) return;
          const clients = (res?.data?.users || []).map(toOption);
          setData((prev) => (pageToLoad === 1 ? clients : mergeUniqueClients(prev, clients)));
          setTotalPages(res?.data?.pagination?.totalPages || 1);
          setPage(pageToLoad);
        })
        .finally(() => {
          if (seq !== seqRef.current) return;
          loadingRef.current = false;
          setLoading(false);
        });
    },
    [userId]
  );

  // ÐÐ¾Ð²ÑÐ¹ Ð·Ð°Ð¿ÑÐ¾Ñ â Ð²ÑÐµÐ³Ð´Ð° Ñ Ð¿ÐµÑÐ²Ð¾Ð¹ ÑÑÑÐ°Ð½Ð¸ÑÑ. ÐÑÑÑÐ°Ñ ÑÑÑÐ¾ÐºÐ° ÑÐ¾Ð¶Ðµ ÑÑÐ¸ÑÐ°ÐµÑÑÑ
  // ÑÐ¼ÐµÐ½Ð¾Ð¹ Ð·Ð°Ð¿ÑÐ¾ÑÐ°: Ð¾ÑÐ¸ÑÑÐ¸Ð»Ð¸ Ð¿Ð¾Ð¸ÑÐº â Ð²ÐµÑÐ½ÑÐ»Ð¸ Ð¿Ð¾Ð»Ð½ÑÐ¹ ÑÐ¿Ð¸ÑÐ¾Ðº.
  // Ð¡ÑÐ°ÑÑÐ¾Ð²Ð¾Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ '' â ÑÑÐ¾Ð±Ñ ÑÐ¿Ð¸ÑÐ¾Ðº Ð½Ðµ Ð³ÑÑÐ·Ð¸Ð»ÑÑ Ð½Ð° Ð¼Ð°ÑÐ½ÑÐµ: Ð¿ÐµÑÐ²ÑÐ¹ Ð·Ð°Ð¿ÑÐ¾Ñ
  // ÑÑÐ¾Ð´Ð¸Ñ Ð¿Ð¾ Ð¾ÑÐºÑÑÑÐ¸Ñ Ð¼ÐµÐ½Ñ, ÐºÐ°Ðº Ð¸ ÑÐ°Ð½ÑÑÐµ.
  const lastLoadedTerm = useRef('');
  useEffect(() => {
    if (lastLoadedTerm.current === debouncedSearch) return;
    lastLoadedTerm.current = debouncedSearch;
    load(1, debouncedSearch);
  }, [debouncedSearch, load]);

  const onMenuOpen = useCallback(() => {
    if (data.length === 0) load(1, debouncedSearch);
  }, [data.length, debouncedSearch, load]);

  const loadMore = useCallback(() => {
    if (loadingRef.current || page >= totalPages) return;
    load(page + 1, debouncedSearch);
  }, [load, page, totalPages, debouncedSearch]);

  // excludeIds Ð¾ÑÑÐµÐºÐ°ÐµÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ¾Ð², ÐºÐ¾ÑÐ¾ÑÑÐµ Ð¿Ð¾ÐºÑÐ¿Ð°ÑÐµÐ»ÐµÐ¼ Ð² ÑÑÐ¾Ð¹ ÑÐ´ÐµÐ»ÐºÐµ Ð±ÑÑÑ Ð½Ðµ Ð¼Ð¾Ð³ÑÑ
  // (Ð¿ÑÐ¾Ð´Ð°Ð²ÐµÑ ÐºÐ¾Ð¼Ð¸ÑÑÐ¸Ð¾Ð½Ð½Ð¾Ð³Ð¾ Ð°Ð²ÑÐ¾ ÑÐ°Ð¼ Ñ ÑÐµÐ±Ñ Ð½Ðµ Ð¿Ð¾ÐºÑÐ¿Ð°ÐµÑ).
  const options = data.filter((item) => !excludeIds?.includes(item.value));

  return (
    <Select
      handleSetSelect={(val, meta) => {
        // Ð¡Ð±ÑÐ¾Ñ ÑÑÑÐ¾ÐºÐ¸ Ð¿ÑÐ¸ Ð·Ð°ÐºÑÑÑÐ¸Ð¸ Ð¼ÐµÐ½Ñ â Ð½Ðµ Ð¿Ð¾Ð¸ÑÐº, Ð¿ÐµÑÐµÐ·Ð°Ð¿ÑÐ°ÑÐ¸Ð²Ð°ÑÑ Ð½Ðµ Ð½Ð°Ð´Ð¾.
        if (!meta || meta.action === 'input-change') setSearch(val);
        if (handleSetSelect) handleSetSelect(val, meta);
      }}
      handleSetState={handleSetState}
      options={options}
      title={'ÐÐ»Ð¸ÐµÐ½Ñ'}
      placeholder={'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°'}
      onFocus={loadMore}
      onMenuOpen={onMenuOpen}
      style={style}
      isSearchable
      isLoading={loading}
      {...props}
    />
  );
};

export default SelectClients;
